import React, { useContext } from 'react';

import { BrowserBreakpoints, Desktop, DesktopLarge, Mobile, Tablet } from './Breakpoints';
import { initialValue, useBrowserInternal } from './UseBrowser';

export type ResponsiveContext = { browser: BrowserBreakpoints };

const Responsive = React.createContext<ResponsiveContext>({ browser: initialValue });
Responsive.displayName = 'ResponsiveContext';

export const useResponsive = () => useContext(Responsive);

export const ResponsiveConsumer = Responsive.Consumer;

export const ResponsiveProvider: React.FC = ({ children }) => {
  const { browser, setIsMobile, setIsTablet, setIsDesktop, setIsDesktopLarge } = useBrowserInternal();

  return (
    <>
      <Mobile>
        {mobile => {
          setIsMobile(mobile);
          return null;
        }}
      </Mobile>
      <Tablet>
        {isTablet => {
          setIsTablet(isTablet);
          return null;
        }}
      </Tablet>
      <Desktop>
        {matches => {
          setIsDesktop(matches);
          return null;
        }}
      </Desktop>
      <DesktopLarge>
        {matches => {
          setIsDesktopLarge(matches);
          return null;
        }}
      </DesktopLarge>
      <Responsive.Provider value={{ browser }}>
        {children}
      </Responsive.Provider>
    </>
  );
};
